export default __webpack_public_path__ + "static/media/a017-market-9.2a23c01a.svg";